function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "cancel-svgrepo-com",
  transform: "translate(0.002 -0.111)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5347",
  "data-name": "Group 5347",
  transform: "translate(-0.002 0.111)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5346",
  "data-name": "Group 5346",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3863",
  "data-name": "Rectangle 3863",
  width: 7.814,
  height: 62.146,
  transform: "translate(49.473 43.944) rotate(135)",
  fill: "#e02a2a"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3864",
  "data-name": "Rectangle 3864",
  width: 25.167,
  height: 7.814,
  transform: "translate(0 43.949) rotate(-45)",
  fill: "#e02a2a"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3865",
  "data-name": "Rectangle 3865",
  width: 25.167,
  height: 7.814,
  transform: "translate(49.497 5.556) rotate(135)",
  fill: "#e02a2a"
}))));

function SvgFailedTopUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.497,
    height: 49.474,
    viewBox: "0 0 49.497 49.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTopUpIcon);
export default __webpack_public_path__ + "static/media/failed-top-up-icon.2ecf5749.svg";
export { ForwardRef as ReactComponent };